import { SecondaryNavKey } from './models/secondary-nav-key';
import { SecondaryNavOption } from './models/secondary-nav-option';
import { observeSecondaryNavOptions } from './repositories/secondary-nav.repository';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { NgIf, NgFor, AsyncPipe, NgStyle } from '@angular/common';
import { subscribeOnce } from '@tmx/core';

@Component({
  selector: 'app-secondary-nav',
  templateUrl: './secondary-nav.component.html',
  styleUrls: ['./secondary-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, NgFor, NgStyle, RouterLinkActive, RouterLink, AsyncPipe],
})
export class SecondaryNavComponent {
  options$: Observable<SecondaryNavOption[]> | null = null;
  numberOfOptions = 0;

  @Input() set key(value: SecondaryNavKey) {
    this.options$ = observeSecondaryNavOptions(value);
    subscribeOnce(this.options$, (options) => {
      this.numberOfOptions = options.length;
    });
  }
  @Input() active = false;
}
